export const actionsEnum = {
    edit: 'edit',
    delete: 'delete',
    print: 'print',
    showDetails: 'showDetails',
    accept: 'accept',
    copy: 'copy',
};